import React from "react";

const AppML_WebSQL = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML WebSQL</h1>
      <p>This is the AppML WebSQL page content.</p>
    </div>
  );
};

export default AppML_WebSQL;
